module.exports = __webpack_public_path__ + "static/media/banner.aca34ffa.jpg";